import ArrowDownIcon from "@pages/profile-v2/assets/icons/ArrowDownIcon.jsx";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
	BonusItemWrapper,
	ButtonText,
	ContentInfo,
	Date,
	DateWrapper,
	Detail,
	DetailWrapper,
	DetailsButton,
	ExpiredBonusItemWrapper,
	ExpiredInfoHeader,
	Info,
	InfoTitle,
	ItemContent,
	ItemHeader,
	WagerInfo,
} from "./elements";

const BonusItem = ({
	data,
	index,
	translate,
	openIndex,
	setOpenIndex,
	isOverLimit,
	isExpired,
	isPendingItem,
}) => {
	const bonusName = isPendingItem ? data?.bonusName : data?.bonus?.name;
	const amount = isPendingItem
		? data?.amountToDisplay?.value
		: data?.walletContributions?.[0]?.amount?.value;
	const currency = isPendingItem
		? data?.amountToDisplay?.currency
		: data?.walletContributions?.[0]?.amount?.currency;
	const wagerPercentage = data?.walletContributions?.[0]?.wageringRatio || 0;
	const startDate = isPendingItem
		? moment(Number(data?.timestamp)).format("DD/MM/YYYY HH:mm")
		: moment(data?.baseAmountDetails?.convertedAt).format("DD/MM/YYYY HH:mm");

	const endDate = isPendingItem
		? moment(Number(data?.timestamp))
				.add(data?.bonusDetail?.claimExpirationDays, "days")
				.format("DD/MM/YYYY HH:mm")
		: moment(data?.baseAmountDetails?.convertedAt)
				.add(data?.bonus?.triggerExpirationDays, "days")
				.format("DD/MM/YYYY HH:mm");

	const allowedTargets = isPendingItem
		? Object.keys(data?.bonusDetail?.limits || {}).filter(
				(key) => data?.bonusDetail?.limits?.[key]?.isAllowed
			)
		: Object.keys(data?.bonus?.limits || {}).filter(
				(key) => data?.bonus?.limits?.[key]?.isAllowed
			);

	const areDetailsOpen = openIndex === index;

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const shouldShowDetails = windowWidth >= 768 || areDetailsOpen;

	const status = isOverLimit
		? "overlimit"
		: isExpired
			? "expired"
			: isPendingItem
				? "expired"
				: "deactive";

	const handleExpiredHeader = (translate) => {
		switch (status) {
			case "expired":
				return translate("BONUS_EXPIRED");
			case "overlimit":
				return translate("BONUS_AMOUNT_IS_OVER");
			case "deactive":
				return translate("BONUS_DEACTIVE");
			default:
				return "";
		}
	};

	return (
		<ExpiredBonusItemWrapper>
			<ExpiredInfoHeader>{handleExpiredHeader(translate)}</ExpiredInfoHeader>
			<BonusItemWrapper>
				<ItemHeader>{bonusName}</ItemHeader>
				<ItemContent>
					<ContentInfo>
						<InfoTitle>{translate("BONUS")}:</InfoTitle>
						<Info>
							{amount} {currency}
						</Info>
					</ContentInfo>
					<WagerInfo>{`%${parseFloat(wagerPercentage)}`}</WagerInfo>
				</ItemContent>
				{shouldShowDetails ? (
					<DetailWrapper>
						<Detail>{`Available in ${allowedTargets
							.map((i) => i.toUpperCase())
							.join(", ")}`}</Detail>
						<DateWrapper>
							<Date>
								{translate("Start")}: {startDate}
							</Date>
							<Date>
								{translate("Last")}: {endDate}
							</Date>
						</DateWrapper>
					</DetailWrapper>
				) : null}
				{windowWidth < 768 && (
					<DetailsButton
						rotate={areDetailsOpen}
						onClick={() => setOpenIndex(areDetailsOpen ? -1 : index)}>
						<ButtonText>
							{!areDetailsOpen ? translate("DETAILS") : translate("HIDE")}
						</ButtonText>
						<ArrowDownIcon />
					</DetailsButton>
				)}
			</BonusItemWrapper>
		</ExpiredBonusItemWrapper>
	);
};

export default BonusItem;
